import React, { useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { useSelector } from 'react-redux';
import './toast.css';
const ToastComponent = () => {
  const toaster = useSelector((state) => state.toaster);

  useEffect(() => {
    if (toaster.show) {
      toast.current.show({
        severity: toaster.type,
        summary: toaster.title,
        detail: toaster.msg,
        life: 3000
      });
    }
  }, [toaster]);

  const toast = React.createRef();

  return (
    <div className="toast-container">
      <Toast ref={toast} position="top-center" className="custom-toast" />
    </div>
  );
};

export default ToastComponent;
